import React from "react";
import {
  render,
  NODE_PARAGRAPH,
  NODE_UL,
  NODE_OL,
  NODE_LI,
  NODE_HR,
  MARK_BOLD,
  MARK_ITALIC,
  MARK_UNDERLINE,
  MARK_LINK,
  MARK_STRIKE,
} from "storyblok-rich-text-react-renderer";

export default function RichText({ richText, className }) {
  const resolvers = {
    nodeResolvers: {
      [NODE_PARAGRAPH]: (children) => <p className={`mb-4 `}>{children}</p>,

      [NODE_UL]: (children) => (
        <ul className="list-disc pl-5 mb-4">{children}</ul>
      ),

      [NODE_OL]: (children) => (
        <ol className="list-decimal pl-5 mb-4">{children}</ol>
      ),

      [NODE_LI]: (children) => <li className="mb-2">{children}</li>,

      [NODE_HR]: () => (
        <hr className="my-6 border-t border-primary-accent dark:border-primary-accent" />
      ),
    },

    markResolvers: {
      [MARK_BOLD]: (children) => <strong>{children}</strong>,

      [MARK_ITALIC]: (children) => <em>{children}</em>,

      [MARK_UNDERLINE]: (children) => (
        <span style={{ textDecoration: "underline" }}>{children}</span>
      ),
      [MARK_STRIKE]: (children) => (
        <span className="line-through decoration-primary-accent">
          {children}
        </span>
      ),

      [MARK_LINK]: (children, { href, target }) => (
        <a
          href={href}
          target={target || "_self"}
          rel={target === "_blank" ? "noopener noreferrer" : undefined}
          className="text-tertiary-accent underline hover:text-tertiary-accent/80"
        >
          {children}
        </a>
      ),

      customTextStyle: (children, { attrs }) => (
        <span style={{ color: attrs.color }}>{children}</span>
      ),
    },
  };

  const renderedRichText = render(richText, resolvers);

  return <div className={className}>{renderedRichText}</div>;
}
